// Prototype. Do not instantiate, but extend this class in order to create custom column cells.
// https://www.ag-grid.com/javascript-data-grid/column-headers/#custom-component
// Don't forget to use OnPush change detection strategy and
// list localStore as a component provider
// https://codecraft.tv/courses/angular/dependency-injection-and-providers/ngmodule-providers-vs-component-providers-vs-component-viewproviders/
// in child classes

import { Component, ElementRef } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({ template: '' })
export abstract class AgHeaderComponent<T extends IHeaderParams> implements IHeaderAngularComp {

  private readonly params: BehaviorSubject<T> = new BehaviorSubject<T>(null);
  private readonly elementRef: ElementRef;

  protected readonly params$: Observable<T> = this.params.asObservable();

  protected constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  /**
   * The method is called on the header component once.
   * @param params
   */
  agInit(params: T): void {
    this.params.next(params);
  }

  /**
   * Gets called when a new Column Definition has been set for this header.
   * If you handle the refresh of your header return true otherwise return false
   * and the grid will re-create your header from scratch.
   * @param params
   */
  refresh(params: T): boolean {
    this.params.next(params);
    return true;
  }

  /**
   * Show column menu
   * @param params
   */
  onMenuClick(params: T) {
    params.showColumnMenu(this.querySelector('.filterMenu'));
  }

  /**
   * Set sorting
   * @param event
   * @param params
   */
  onSortRequested(event: MouseEvent, params: T) {
    params.progressSort(event.shiftKey);
  };

  protected querySelector(selector: string) {
    return <HTMLElement>this.elementRef.nativeElement.querySelector(selector);
  }

}
